import keyMirror from 'keymirror';

import type { TFunction } from 'i18next';

export const errorHandlerActionTypes = keyMirror({
	HANDLE_ERROR: null,
	CLEAR_ERROR: null,
});

export const getErrorInfoDependsOfStatusCode = (
	statusCode: number | string,
	params: string,
	t?: TFunction,
): string => {
	let errorMessage = '';
	if (statusCode === 404) {
		errorMessage = `404.${params}`;
	} else if (statusCode === 403) {
		errorMessage = `403.${params}`;
	} else {
		errorMessage = `500.${params}`;
	}
	return t ? t(errorMessage) : errorMessage;
};
